import { createConnectTransport } from "@connectrpc/connect-web";
import { BACKEND_BASE_URL, createServiceClientFactory } from "@viajero/shared-ui/rpc";
import { getCaseToken } from "@/lib/caseToken";
import {
  caseTokenInterceptor,
  npsTokenInterceptor,
  reservationTokenInterceptor,
} from "@/lib/interceptors";
import { getNPSToken } from "@/lib/npsToken";
import { getReservationToken } from "@/lib/reservationToken";

// transport はモジュール初期化時に 1 度だけ生成し、全 client で使い回す (manager / concierge と同方式)。
// 各 interceptor は呼び出し毎に getter を評価し、x-case-token / x-reservation-token /
// x-nps-token ヘッダを最新に保つ。
export const transport = createConnectTransport({
  baseUrl: BACKEND_BASE_URL,
  interceptors: [
    caseTokenInterceptor(getCaseToken),
    reservationTokenInterceptor(getReservationToken),
    npsTokenInterceptor(getNPSToken),
  ],
});

/**
 * getServiceClient は任意の Connect-ES サービスに対する型付きクライアントを生成する。
 */
export const getServiceClient = createServiceClientFactory(transport);
